module.exports = __webpack_public_path__ + "static/img/index_07.04f6837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_07.png
// module id = otOo
// module chunks = 1